<div class='header-container'>
  <div
    role='button'
    tabindex='0'
    (click)='returnToPreviousPage()'
    (keyup.enter)='returnToPreviousPage()'
    class='back-button-container'>
    <ng-icon name='saxArrowLeft2Outline' size='19px' class='dsp-color-text-neutral' />
    <span class='s-semi-bold dsp-color-text-neutral'>Back</span>
  </div>
  <div class='user-info-container user-data-display-container'>
    <div class='user-detail-container'>
      <ng-container *ngIf='user'>
        <span class='xs-semi-bold dsp-color-text-neutral'>{{ user.displayName }}</span>
        <span class='xxxs-regular dsp-color-text-quiet'>DMI</span>
      </ng-container>
    </div>
    <div class='user-icon-container'>
      <ng-icon name='saxProfileTickOutline' size='16px' class='icon'></ng-icon>
    </div>
  </div>
</div>
